import { useState, useEffect, useRef } from "react";
import "./SimpleSearchBox.css";
import DynamicTextField from "../Textfield/Textfield";
import Button from "../Button/Button";
import dropRoundLight from "../../Assets/Images/drop-down-round-light.svg";
import dropRoundDark from "../../Assets/Images/drop-down-round-dark.svg";
import candidateResumeIcon from "../../Assets/Images/candidate-upload-resume-icon.svg";
import FileIcon from "../../Common/Common-Function/IconMapping";
import { displayFileName } from "../../Common/Common-Function/CommonFunctions";
import CancelIcon from "@mui/icons-material/Cancel";
import TextArea from "../../Common/TextArea/TextArea";
import { Toast } from "../../Common/Toast-Snackbar/ToastSnackbar";
import Badge from "@mui/material/Badge";
import searchFilterIcon from "../../Assets/Images/search-filter-icon.svg";
import SimpleSearchDarkIcon from "../../Assets/Images/Candidates Search Icon Dark.svg";
import SimpleSearchLightIcon from "../../Assets/Images/Candidates Search Icon Light.svg";
import SidePopup from "../SidePopup/SidePopup";
const SimpleCepheaChat = ({
  jobDescriptionValue = "",
  askMeAnythingValue = "",
  minYearsOfExperienceValue = "",
  maxYearsOfExperienceValue = "",
  industryValue = "",
  skillsValue = "",
  locationValue = "",
  jobDescriptionOnChange,
  onAskChange,
  onSubmit,
  uploadedFiles = [],
  onFileUpload,
  onFileDelete,
  askMeAnythingPlaceholder = "Search",
  jobDescriptionPlaceholder = "Enter any details about the job you're looking to fill.",
  subText,
  isDarkMode,
  buttonLabel = "Search",
  inputsectionstyle,
  inputsectionstylewrap,
  TextAreaStyle,
  isCollapsed = false,
  onCollapseChange,
  onClearForm,
  showJobDescriptionField = true,
  showJobDescalone = false,
  showAttachResume = true,
  showExperienceAndLocation = true,
  submitErrorMessage = "Please enter a query.",
  recommendedSearchBoxTitle = "Recommend Candidate Search",
  askmeanythingOnKeyDown = () => {},
  headerRightContent = null,
  inlineActionsRight = null,
  showCepheaActions = false,
  isSimpleSearchLoading = false,
  onClearSimpleSearch,
  onChatWithCephea,
  inlineActionsLeft = null,
  showChatWithCephea = null,
  placeholderOptions = [],
  isHeaderNeeded = true,
  clearButtonLabel = "✕ Clear Search",
  advancedFilterContent = null,
  onAdvancedFilterClick = null,
  isAdvancedFilterOpen = undefined,
  totalActiveFiltersCount = undefined,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSimpleSearchLoading) return;
    const hasFiles = Array.isArray(uploadedFiles) && uploadedFiles.length > 0;
    const hasJobDescription = jobDescriptionValue?.trim();
    const hasAskMeAnything = askMeAnythingValue?.trim();
    const hasSkills = skillsValue?.trim();
    const hasMinExperience = minYearsOfExperienceValue?.trim();
    const hasMaxExperience = maxYearsOfExperienceValue?.trim();
    const hasIndustry = industryValue?.trim();
    const hasLocation = locationValue?.trim();

    if (
      hasFiles ||
      hasJobDescription ||
      hasAskMeAnything ||
      hasSkills ||
      hasMinExperience ||
      hasMaxExperience ||
      hasIndustry ||
      hasLocation
    ) {
      onSubmit();
    } else {
      Toast("error", submitErrorMessage);
    }
  };

  const [collapsed, setCollapsed] = useState(false);
  const fileInputRef = useRef(null);
  const [dynamicPlaceholder, setDynamicPlaceholder] = useState("");
  const [isPlaceholderActive, setIsPlaceholderActive] = useState(true);
  const [placeholderIndex, setPlaceholderIndex] = useState(0);
  const [placeholderCharIndex, setPlaceholderCharIndex] = useState(0);
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);

  useEffect(() => {
    if (!placeholderOptions || placeholderOptions.length === 0) {
      setDynamicPlaceholder("");
      return;
    }

    if (!isPlaceholderActive) {
      setDynamicPlaceholder("");
      setPlaceholderCharIndex(0);
      return;
    }

    const current = placeholderOptions[placeholderIndex];
    if (placeholderCharIndex >= current.length) {
      const timeout = setTimeout(() => {
        const nextIndex = (placeholderIndex + 1) % placeholderOptions.length;
        setPlaceholderIndex(nextIndex);
        setPlaceholderCharIndex(0);
        setDynamicPlaceholder("");
      }, 1200);

      return () => clearTimeout(timeout);
    }
    const timeout = setTimeout(() => {
      setDynamicPlaceholder((prev) => prev + current[placeholderCharIndex]);
      setPlaceholderCharIndex((prev) => prev + 1);
    }, 80);

    return () => clearTimeout(timeout);
  }, [
    placeholderCharIndex,
    placeholderIndex,
    isPlaceholderActive,
    placeholderOptions,
  ]);

  useEffect(() => {
    if (isCollapsed !== collapsed) {
      setCollapsed(isCollapsed);
    }
  }, [isCollapsed, collapsed]);

  useEffect(() => {
    if (onClearForm && fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }, [onClearForm]);

  const formatFileSize = (sizeInBytes) => {
    if (sizeInBytes < 1024) return `${sizeInBytes} bytes`;
    else if (sizeInBytes < 1048576)
      return `${(sizeInBytes / 1024).toFixed(2)} KB`;
    else return `${(sizeInBytes / 1048576).toFixed(2)} MB`;
  };

  const toggleCollapse = () => {
    const newCollapsedState = !collapsed;
    setCollapsed(newCollapsedState);
    if (onCollapseChange) {
      onCollapseChange(newCollapsedState);
    }
  };

  const renderedInlineActions =
    typeof inlineActionsRight === "function"
      ? inlineActionsRight({ isExpanded: false })
      : inlineActionsRight;

  const handleAskChange = (e) => {
    if (isPlaceholderActive) {
      setIsPlaceholderActive(false);
    }
    if (onAskChange) onAskChange(e);
  };

  const handleAskClick = () => {
    setIsPlaceholderActive(false);
  };

  const handleAskBlur = () => {
    if (!askMeAnythingValue || askMeAnythingValue.trim() === "") {
      setIsPlaceholderActive(true);
    }
  };

  const fallbackFiltersCount = [
    skillsValue,
    minYearsOfExperienceValue,
    maxYearsOfExperienceValue,
    industryValue,
    locationValue,
  ].filter((val) => val && String(val).trim() !== "").length;

  const activeFiltersCount =
    totalActiveFiltersCount !== undefined
      ? totalActiveFiltersCount
      : fallbackFiltersCount;
  const advancedFilterOpen =
    isAdvancedFilterOpen !== undefined
      ? isAdvancedFilterOpen
      : showAdvancedSearch;

  const renderAdvancedFilterContent = () => {
    if (!advancedFilterContent) return null;
    if (typeof advancedFilterContent === "function") {
      return advancedFilterContent({
        closeSidePopup: () => setShowAdvancedSearch(false),
      });
    }
    return advancedFilterContent;
  };

  return (
    <div className={
      isHeaderNeeded
        ? "simple-search-container"
        : "simple-search-container-no-header"
    }>
      {isHeaderNeeded && (
      <div
        className={`recommended-search-header${collapsed ? " collapsed" : ""}`}
        style={{
          borderBottomLeftRadius: collapsed ? "16px" : "0px",
          borderBottomRightRadius: collapsed ? "16px" : "0px",
        }}
      >
        <img
          src={isDarkMode ? SimpleSearchDarkIcon : SimpleSearchLightIcon}
          alt="Jelly Icon"
          className="jelly-icon"
        />
        <span className="recommended-search-title">
          {recommendedSearchBoxTitle}
        </span>
        <span className="recommended-search-subtext">{subText}</span>
        {headerRightContent && (
          <div className="recommended-header-actions">{headerRightContent}</div>
        )}
        <img
          src={isDarkMode ? dropRoundDark : dropRoundLight}
          style={{
            transform: collapsed ? "rotate(0deg)" : "rotate(180deg)",
            transition: "transform 0.25s ease",
          }}
          alt="Toggle"
          className={`dropdown-icon toggle-icon ${
            collapsed ? "collapsed" : ""
          }`}
          onClick={toggleCollapse}
        />
      </div>
      )}

      {!collapsed && (
        <>
          <div
            className="rec-search-input-section-wrap"
            style={{ ...inputsectionstylewrap }}
          >
            {showJobDescalone ? (
              <div
                className="rec-search-input-section"
                style={{ ...inputsectionstyle }}
              >
                <DynamicTextField
                  style={{
                    paddingLeft: "20px",
                    width: "100%",
                    border: "1px solid var(--search-input-section-border)",
                    borderRight: "none",
                    borderRadius: "10px 0px 0px 10px",
                  }}
                  containerStyle={{ flexGrow: 1, width: "auto" }}
                  placeholder={jobDescriptionPlaceholder}
                  className="ai-search-textfield"
                  name="jobDescription"
                  value={jobDescriptionValue}
                  onChange={jobDescriptionOnChange}
                />

                <Button
                  label={buttonLabel}
                  event={handleSubmit}
                  backgroundColor="var(--search-button-background-color)"
                  color="#ffffff"
                  iconWidth="20px"
                  className="search-button-sharp-left"
                  superShine={true}
                  style={{
                    borderTopLeftRadius: "0",
                    borderBottomLeftRadius: "0",
                    borderTopRightRadius: "10px",
                    borderBottomRightRadius: "10px",
                    backgroundColor: "var(--search-button-background-color)",
                    color: "#ffffff",
                    padding: "10px 10px",
                  }}
                />
              </div>
            ) : (
              <>
                {showJobDescriptionField && (
                  <TextArea
                    placeholder={jobDescriptionPlaceholder}
                    className="ai-search-textfield"
                    name="jobDescription"
                    value={jobDescriptionValue}
                    onChange={jobDescriptionOnChange}
                    style={{ ...TextAreaStyle }}
                  />
                )}
                <div className="search-input-with-advanced">
                  <div
                    className="rec-search-input-section"
                    style={{ ...inputsectionstyle }}
                  >
                    {inlineActionsLeft && (
                      <div className="simple-inline-actions rec-inline-actions-left">
                        {typeof inlineActionsLeft === "function"
                          ? inlineActionsLeft({ isExpanded: false })
                          : inlineActionsLeft}
                      </div>
                    )}

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        flex: 1,
                        border: "1px solid var(--search-input-section-border)",
                        borderRight: "none",
                        borderRadius: "10px 0px 0px 10px",
                        backgroundColor: "var(--body__background)",
                        paddingLeft: "20px",
                        paddingRight: "8px",
                      }}
                    >
                      <textarea
                        value={askMeAnythingValue}
                        onChange={handleAskChange}
                        onClick={handleAskClick}
                        onBlur={handleAskBlur}
                        name="askmeanything"
                        placeholder={
                          dynamicPlaceholder ||
                          (isPlaceholderActive && placeholderOptions?.length > 0
                            ? ""
                            : askMeAnythingPlaceholder)
                        }
                        style={{
                          width: "100%",
                          border: "none",
                          backgroundColor: "transparent",
                          height: "30px",
                          color: "var(--header__color)",
                          paddingTop: "9px",
                          overflowY: "auto",
                          outline: "none",
                          resize: "none",
                        }}
                        onKeyDown={askmeanythingOnKeyDown}
                      />

                      {showCepheaActions && !isSimpleSearchLoading && (
                        <div className="simple-inline-actions">
                          <Button
                            label={clearButtonLabel}
                            event={onClearSimpleSearch}
                            className="cephea-clear-search-button"
                          />
                        </div>
                      )}
                    </div>                   

                    <Button
                      label={buttonLabel}
                      event={handleSubmit}
                      disabled={isSimpleSearchLoading}
                      backgroundColor="var(--search-button-background-color)"
                      color="#ffffff"
                      iconWidth="20px"
                      className="search-button-sharp-left"
                      superShine={true}
                      style={{
                      borderRadius: "0px 10px 10px 0px",
                        backgroundColor:
                          "var(--search-button-background-color)",
                        color: "#ffffff",
                        opacity: isSimpleSearchLoading ? 0.6 : 1,
                      cursor: isSimpleSearchLoading ? "not-allowed" : "text",
                        padding: "12px 14px",
                      }}
                    />
                    {renderedInlineActions && (
                      <div className="simple-inline-actions">
                        {renderedInlineActions}
                        </div>
                      )}

                    <div style={{padding: '5px'}}>
                      {showExperienceAndLocation && (
                        <Button
                          label={
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                fontWeight: "500",
                              }}
                            >
                              <Badge
                                badgeContent={activeFiltersCount}
                                color="primary"
                                invisible={activeFiltersCount === 0}
                                sx={{
                                  "& .MuiBadge-badge": {
                                    fontSize: "10px",
                                    height: "16px",
                                    minWidth: "16px",
                                    backgroundColor: isDarkMode
                                      ? "#9d97f5"
                                      : "#6860ee",
                                  },
                                }}
                              >
                                <img
                                  src={searchFilterIcon}
                                  alt="Filter"
                                  style={{ width: "20px", height: "30px" }}
                                />
                              </Badge>
                              Filters
                            </span>
                          }
                          event={() => {
                            if (onAdvancedFilterClick) {
                              onAdvancedFilterClick();
                              return;
                            }
                            setShowAdvancedSearch(true);
                          }}
                          className={`advanced-filter-btn ${
                            advancedFilterOpen ? "active" : ""
                          }`}
                          style={{
                            backgroundColor: isDarkMode
                              ? "rgba(157, 151, 245, 0.15)"
                              : "#f0efff",
                            color: isDarkMode ? "#9d97f5" : "#6860ee",
                            padding: "6px 12px",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            whiteSpace: "nowrap",
                            border: "none",
                            boxShadow: "none",
                          }}
                        />
                      )}
                      </div>
                    </div>
                </div>
              </>
            )}
          </div>

          {showAttachResume ? (
            <>
              <div className="uploaded-files-container">
                {Array.isArray(uploadedFiles) && uploadedFiles.length > 0 && (
                  <div className="create-uploaded-files-items-list">
                    {uploadedFiles.map((file, index) => (
                      <div className="uploaded-filenames" key={index}>
                        <FileIcon fileName={file.name} />
                        <div className="uploaded-file-container">
                          <div className="uploaded-filename">
                            {displayFileName(file.name)}
                          </div>
                          <div className="uploaded-file-size">
                            {formatFileSize(file.size)}
                          </div>
                        </div>
                        <CancelIcon
                          className="ai-close-icon"
                          onClick={() => onFileDelete(file.name)}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div
                className="rec-attach-container"
                style={{ marginBottom: "2%", marginTop: "10px" }}
              >
                <label htmlFor="file-upload" className="attach-label">
                  <img
                    alt=""
                    src={candidateResumeIcon}
                    style={{ width: "24px" }}
                  />
                  <div className="attach-label-text">Attach Resume</div>
                </label>
                <input
                  id="file-upload"
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={onFileUpload}
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  multiple
                />
              </div>
            </>
          ) : null}
        </>
      )}
      {showExperienceAndLocation && !onAdvancedFilterClick && (
        <SidePopup
          isOpen={showAdvancedSearch}
          onClose={() => setShowAdvancedSearch(false)}
          headerBackgroundColor="var(--sidepopup-background)"
          headerContent={
            <div className="advanced-search-popup-header">
              <h2>Filters</h2>
              <p>Refine your search to find the right candidates</p>
            </div>
          }
          sidePopupWidth="560px"
          contentPadding="0"
          closeOnOverlayClick
          className="advanced-filter-sidepopup"
        >
          {renderAdvancedFilterContent()}
        </SidePopup>
      )}
    </div>
  );
};

export default SimpleCepheaChat;